require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-financial-center-invests-in-employee-experience-with-new-vice-president.json") })
        }
      }, "path---articles-financial-center-invests-in-employee-experience-with-new-vice-president");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-financial-center-invests-in-employee-experience-with-new-vice-president!./.cache/json/articles-financial-center-invests-in-employee-experience-with-new-vice-president.json
// module id = 1641
// module chunks = 231608221292675